import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { z } from "zod";
import type { ReasonCodes } from "../../../types/operations/osad.type";
import { http } from "../../../utils/httpCommon";
import { useApiUrls } from "../../useApiUrl";

const reasonCodeSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullish(),
});

export const useReasonCodes = (
  enabled = true
): UseQueryResult<ReasonCodes[], unknown> => {
  const hookUrls = useApiUrls();
  const urls = hookUrls;

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ["reason-codes"],
    queryFn: async () => {
      const { data } = await http.get(urls.common.getReasonCodes);
      return z.array(reasonCodeSchema).parse(data);
    },
    enabled,
  });
};
